import React from 'react';

const FooterPublicComponent = () =>{
    return <div className="an-footer d-flex justify-content-center align-items-center">
        Agua Nuestra &copy; 2020
    </div>
};

export default FooterPublicComponent;
